<template>
  <transition>
    <keep-alive>
      <router-view :key="$route.fullPath" />
    </keep-alive>
  </transition>
</template>

<script>

const WebFont = require('webfontloader')

WebFont.load({
  google: {
    families: ['Roboto:300,400,500,700:latin']
  }
})

export default {
  name: 'PersonalApp'
}
</script>
